<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo/>
  <div [style.flex-grow]="1"></div>
  <div style="padding-right: 4px">
    <spb-toggle-button/>
    @if (service.isLoggedIn()) {
      <button
        [matMenuTriggerFor]="menu"
        mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    }
  </div>
  <mat-menu #menu="matMenu">
    <mat-divider/>
    <button (click)="service.reset()" mat-menu-item>Avsluta</button>
  </mat-menu>
</div>